import { getLemonadeAppLink } from '@/utils/getLemonadeAppLink';

export interface FaqInfoProps {
  question: string;
  answer: string;
  analytics: string;
}

export const faqInfo = (isMobile: boolean): FaqInfoProps[] => [
  {
    question: 'What does a Lemonade Homeowners policy cover? ',
    answer: `Your policy covers your home and property for damage caused by things like wildfires, extreme weather, crime, and vandalism. It also protects you against legal claims for damage or injury you accidentally cause others. <a href="https://www.lemonade.com/homeowners/explained/what-homeowners-insurance-covers/" target="_blank">Learn more about what's covered here</a>.`,
    analytics: 'ho_what_does_the_policy_cover',
  },
  {
    question: 'How can I switch to Lemonade?',
    answer:
      'We make it easy to switch! Once you sign up with us, we’ll send your previous insurer a formal notice. Once they get it, they should cancel the remainder of your policy term and refund you for any outstanding payments.',
    analytics: 'ho_can_i_trust_you_guys',
  },
  {
    question: 'Can I trust you guys?',
    answer:
      'Of course. Unlike most of the new insurance startups out there, Lemonade is an insurance carrier, reinsured by some of the most trusted names in the industry. We’re a public company, traded on the NYSE, and rated A-Exceptional for financial stability.',
    analytics: 'ho_can_i_trust_you_guys',
  },
  {
    question: 'How much does homeowners insurance cost?',
    answer: `Homeowners insurance at Lemonade <a href="https://www.lemonade.com/homeowners/explained/homeowners-insurance-cost/" target="_blank">starts at $25/month</a>, but varies by state and depends on factors including your house’s age, the cost to rebuild, and building materials, as well as the coverage and add-ons you choose. You can lower your homeowners insurance cost <a href="https://www.lemonade.com/homeowners/explained/how-to-buy-cheap-home-insurance-online/" target="_blank">by following these steps</a>.`,
    analytics: 'ho_how_much_does_it_cost',
  },
  {
    question: 'How do I file a claim?',
    answer: `Just open the  ${getLemonadeAppLink(isMobile)}
    and hit the ‘Claim’ button! We’ll guide you through the process from there. After your report is complete, we’ll ask for your bank account information. Once your claim is approved, we’ll deposit your payment, minus your deductible, directly into your account.`,
    analytics: 'ho_how_to_file_a_claim',
  },
  {
    question: 'What bundle options does Lemonade offer?',
    answer: `In addition to homeowners insurance, Lemonade offers renters, car, pet, and term life policies. You can unlock an automatic discount with any combination of policies, like a <a href="https://www.lemonade.com/homeowners/explained/homeowners-and-car-insurance-bundle/" target="_blank">homeowners and car bundle</a>, so it’s both a great way to consolidate your insurance needs and an opportunity to save.`,
    analytics: 'ho_how_do_i_get_paid',
  },
  {
    question: 'What if I want to cancel my policy or make changes to it?',
    answer: `You can cancel your policy at any time via the Lemonade app or website, and you’ll receive a refund for the remaining period you’ve already paid for. If you want to change your coverage amounts or add additional coverage, simply open the <a href="https://www.lemonade.com/download" target="_blank">Lemonade app</a> or  <a href="https://www.lemonade.com/login#email" target="_blank">access your account here</a>.`,
    analytics: 'ho_policy_cancelation',
  },
  {
    question: 'What kind of payments do you accept?',
    answer:
      'We can take care of everything through your lender or bank (escrow), or you can pay directly using your credit card.',
    analytics: 'ho_payments_methods',
  },
  {
    question: 'Does Lemonade offer homeowners insurance near me?',
    answer: `Lemonade Homeowners insurance is available in 23 states—to find out if it’s available near you, <a href="https://www.lemonade.com/lemonade-goes-global" target="_blank">check out where we sell our homeowners insurance</a> and our other products.`,
    analytics: 'ho_coffer_insurance_near_me',
  },
];
